try {
    require("ckeditor");
    require("ckeditorJquery");
} catch (e) {
    console.log(e);
}
import Optional from 'optional-js';
import i18n from 'l10n';
import callingCode from 'callingcodewithdefaultcountry';
import moment from 'moment-timezone';
import countriesCode from 'countriescode';
import dhtmlx from 'dhtmlxAdapter';
import md5 from 'md5';
import {$, _, Backbone} from "backboneAdapter";
import {equals, includedIn} from "../utils/predicates";
import {on} from "../adapters/backbone-decorators";
import JEditable from "jqueryEditable";

require("interfaceAdapter");
require('metroHelpers');
require('durationPicker');

$.datetimepicker.setDateFormatter('moment');

class GenericView extends Backbone.View {
    // Template = null;
    // template = null;
    /** @type {object}*/
        // customEvents = null;
    myDomId = null;
    domain = null;

    constructor(options) {
        //TODO initialize Backbone.View (super) with options. This requires checking extending classes
        super(options);
        callingCode.init().then(() => console.info("CallingCode library initialized."));

        if (!this.domain)
            this.domain = this.$el;
        else if (typeof this.domain === "string")
            this.domain = $(this.domain);

        this.i18n = i18n;
        /* WTF POINT. TODO: explore */
        const SelectEditable = JEditable.types.select.prototype;
        if (SelectEditable.content === this.originalContentFunction)
            SelectEditable.content = _.wrap(SelectEditable.content,
                function (fun, data, settings, original) {
                    settings.retrieved_data = data;
                    fun(this, data, settings, original);
                });

        if (this.customEvents) {
            this.on(this.customEvents, this)
        }
    }

    // initialize(options) {
    //     if (!this.template) this.template = Handlebars.compile(this.Template);
    // }

    /**
     * Extended render method. Uses a model extension for rendering
     * @param modelExtension
     */
    render(modelExtension) {
        const attributes = _.extend(this.model.toJSON(), modelExtension);
        const templateOutput = this.template(attributes);
        this.$el.html(templateOutput);
        this.domain.find('.edit').each((i, e) => this.makeEditable(i, e, this));
        if (this.myDomId) {
            this.$el.attr("id", this.myDomId());
        }

        this.$('[data-i18n]').i18n();
        return this;
    }

    makeEditableDecimal(i, e) {
        const decimals = $(e).data("decimals");
        const positive = $(e).data("positive");
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`;

        const h = this.extractHandlers(e);
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun));
            input.on("input", () => this.checkValidNumber(e, input, decimals, positive, h.onValid, h.onInvalid));
        };

        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            type: 'text',
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            height: 'inherit',
            width: '',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onblur: 'ignore',
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
            onreset: (settings, el) => h.onReset ? h.onReset(e, $(el).find('input')) : null
        });
    }

    makeEditableDatepicker(i, e) {
        const df = i18n.t('$dateformat');

        let minDate = $(e).data('mindate');
        let maxDate = $(e).data('maxdate');

        // we pass `0` as the date in the corresponding element, when we want it to refer to NOW
        if(minDate == 0)
            minDate = Date.now();

        if(maxDate == 0)
            maxDate = Date.now();

        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const h = this.extractHandlers(e);
        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            type: 'datepicker',
            lang: i18n.truncLang(),
            timepicker: false,
            dateFormat: df,
            format: df,
            minDate: Optional.ofNullable(minDate).orElse(false),
            maxDate: Optional.ofNullable(maxDate).orElse(false),
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            event: 'click',
            onSelect(dateText, inst) {
                //alert(dateText);
            },
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
            onblur: 'ignore',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            width: 'inherit'
        });
    }

    makeEditableDatetimepicker(i, e) {
        const hasClassNow = $(e).hasClass("now");
        const hasClassNever = $(e).hasClass("never");
        const autosave = $(e).hasClass("autosave");

        const h = this.extractHandlers(e);
        $(e).text($(e).text().trim());

        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const df = i18n.t('$dateformat');
        const f = i18n.t('$datetimeformat');
        const tf = i18n.t('$timeformat');

        let minDate = $(e).data('mindate');
        let maxDate = $(e).data('maxdate');

        // we pass `0` as the date in the corresponding element, when we want it to refer to NOW
        if(minDate == 0)
            minDate = Date.now();

        if(maxDate == 0)
            maxDate = Date.now();

        let onblur, submit, cancel;

        if (autosave) {
            onblur = 'submit';
        } else {
            onblur = 'ignore';
            submit = i18n.t("generic.okbtn");
            cancel = i18n.t("generic.cancelbtn");
        }

        const customButton = [{
            classes: "dataNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
            id:"closeButton",
            label:"close",
        }];

        if (hasClassNever) {
            customButton.push({
                classes: "dateNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                id:"neverButton",
                label:"never",
                attrType: $(e).data("attr-type"),
                objectId: $(e).data("object-id")
            });
        }
        if (hasClassNow) {
            customButton.push({
                classes: "dateNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                id:"nowButton",
                label:"now",
                attrType: $(e).data("attr-type"),
                objectId: $(e).data("object-id")
            });
        }

        $(e).editable((value, settings) => this.handleUpdate(value === i18n.t("never") ? null : value, settings, e),
            {
                autosave,
                type: 'datetimepicker',
                lang: i18n.truncLang(),
                dateFormat: df,
                minDate: minDate || false,
                maxDate: maxDate || false,
                showSecond: false,
                showMillisec: false,
                customButton,
                timeFormat: tf,
                stepMinute: 5,
                height: 'inherit',
                tooltip: i18n.t("generic.editclick"),
                placeholder,
                event: 'click',
                onSelect(dateText, inst) {
                    //alert(dateText);
                },
                onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
                onblur,
                submit,
                cancel,
                width: 'inherit'
            });
    }

    makeEditableCheckbox(i, e) {
        const value = $(e).html();
        const input = $('<input>');
        input.attr('type', 'checkbox');
        if ("true" === value) {
            input.prop("checked", "checked");
        }

        $(e).empty();
        $(e).append(input);
        input.after("<span class='check'></span>");

        $(input).bind("click", ev => {
            const curvalue = $(e).find('input').prop("checked");
            this.handleUpdate(curvalue, {type: 'checkbox'}, e);
        });
    }

    makeEditableHtmlWysiwyg(i, e) {

        //add md5 to self for CKEDITOR
        this.md5 = md5;
        const $e = $(e);
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS
        const $frame = $(`<iframe class="iframe-editable"></iframe>`);
        $e.append($frame);
        let $mask = $(`<div class="iframe-mask">`).appendTo($e);

        const doc = $frame.contents().get(0);
        const adjustDisplay = () => {
            $frame.height("");
            if ($frame.is(":visible")) {
                const $p = $e.parent();
                $frame.height(doc.scrollingElement.scrollHeight);
                $e.height($frame.height());
                $frame.width($p.width());
                $mask.height($p.height());
                $mask.width($p.width());
            } else
                $e.height("");
        };
        $frame.on("load", adjustDisplay);
        $frame.one("load", () => {
            adjustDisplay();
            const h = this.extractHandlers(e);
            $e.editable((value, settings) => {
                this.isMessageSaved = true;
                return this.handleUpdate(value, settings, e);
            }, {
                type: 'wysiwyg',
                fullHtml: true,
                tooltip: i18n.t("generic.editclick"),
                placeholder,
                projectionElement: $frame,
                event: 'click',
                submit: i18n.t("generic.okbtn"),
                cancel: i18n.t("generic.cancelbtn"),
                onblur: "ignore",
                oncancel: (settings, el) => {
                    $frame.show();
                    $mask.show();
                    return h.onCancel ? h.onCancel($(el)) : null;
                },
                onsubmit: (settings, el) => {
                    $frame.show();
                    $mask.show();
                    const $el = $(el);
                    return h.onSubmit ? h.onSubmit($el) : null;
                },
                onedit: (settings, el) => {
                    $frame.hide();
                    $mask.hide();
                    return h.onEdit ? h.onEdit($(el)) : null;
                },
                parent: this
            });
        });
        //Write to the iframe document after setting the listeners, to eliminate race condition.
        doc.open();
        doc.write($(e).data("frame-content"));
        doc.close();
        $(e).removeAttr("data-frame-content");
    }

    makeEditableWysiwyg(i, e) {
        //add md5 to self for CKEDITOR
        this.md5 = md5;
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS
        const h = this.extractHandlers(e);
        $(e).editable((value, settings) => {
            this.isMessageSaved = true;
            return this.handleUpdate(value, settings, e);
        }, {
            type: 'wysiwyg',
            fullHtml: false,
            tooltip: this.i18n.t("generic.editclick"),
            placeholder,
            event: 'click',
            submit: this.i18n.t("generic.okbtn"),
            cancel: this.i18n.t("generic.cancelbtn"),
            onblur: "ignore",
            oncancel: (settings, el) => h.onCancel ? h.onCancel($(el)) : null,
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el)) : null,
            onedit: (settings, el) => h.onEdit ? h.onEdit($(el)) : null,
            parent: this
        });
    }

    makeEditableSelect(i, e) {
        const h = this.extractHandlers(e);
        const attr = this.extractAttr(e);
        const options = {
            type: 'select',
            tooltip: 'click to edit…',
            loadtype: 'GET',
            width: '',
            event: 'click',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onblur: 'ignore',
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el)) : null
        };
        if (h.onData) {
            options.data = h.onData();
        } else {
            options.loadurl = this.model.attributeOptionsUrl(attr);
        }
        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), options);
    }

    makeEditableFormattedSelect(i, e) {
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const attr = this.extractAttr(e);
        const attributeUrl = this.model.attributeOptionsUrl(attr);
        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            type: 'formattedselect',
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            loadurl: attributeUrl,
            loadtype: 'GET',
            width: '',
            event: 'click',
            onblur: 'ignore',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn")
        });
    }

    async makeEditableCombobox(i, e, type) {
        const h = this.extractHandlers(e);
        const fetchFor = $(e).data("fetch-for");
        const autocompletion = (h.onData) ? await h.onData(fetchFor) : [];
        const permutation = $(e).data('permutation');
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const p = input => {
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun));
            $(input).css('text-align', 'inherit');

            if (permutation === "url") {
                input.on("input", _.debounce(() => {
                    const url = input.val();
                    this.checkUrl(input, url, h.onValid, h.onInvalid);
                }, 800));
            }
        };

        $(e).editable((value, settings) => {
            if (permutation === "url") {
                if (value !== '') {
                    if (value.indexOf('http://') === -1 && value.indexOf('https://') === -1) {
                        const protocol = 'http://';
                        value = protocol.concat(value);
                    }
                    // Check if url is accessible
                    $.ajaxDefaultQ({
                        url: "/CampaignCloud/checkurl", //Caveat: app-specific URL
                        data: {url: value},
                        success: data => this.onTestUrl && this.onTestUrl(data)
                    });
                } else
                    value = null;
            }
            return this.handleUpdate(value, settings, e);
        }, {
            type,
            autocompletionData: autocompletion,
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            width: '',
            data: text => $('<div />').html(text).text().trim(),
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find("[class*=combobox] input")) : null,
            onreset: () => h.onReset ? h.onReset(e) : null
        });
    }

    makeEditableDefault(i, e, type) {
        const autosave = $(e).hasClass("autosave");
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const h = this.extractHandlers(e);
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            const inputType = $(e).data('type');
            if (inputType) {
                $(input).attr('type', inputType);
            }
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun.bind(this, input, e)));
            if (h.onValid && h.onInvalid) {
                input.on("input", () => {
                    this.checkInputLength(e, input, h.onValid, h.onInvalid);
                });
            }
        };
        let onblur, submit, cancel;
        if (autosave) {
            onblur = 'submit';
        } else {
            onblur = 'ignore';
            submit = i18n.t("generic.okbtn");
            cancel = i18n.t("generic.cancelbtn");
        }
        const onreset = _.wrap(h.onReset || _.noop, (func, settings) => {
            if (func(e) !== false && settings.autosave)
                this.handleUpdate(e.revert, settings, e);
        });
        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            autosave,
            type: type,
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            height: 'inherit',
            rows: 1,
            width: '',
            onblur,
            submit,
            cancel,
            data: text => $('<div />').html(text).text().trim(),
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find(type === 'text' ? 'input' : 'textarea')) : null,
            onreset
        });
    }

    makeEditableTextWithCustomTag(i, e, type, tagName) {
        const autosave = $(e).hasClass("autosave");
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS
        const h = this.extractHandlers(e);
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            const inputType = $(e).data('type');

            if (inputType) {
                $(input).attr('type', inputType);
            }
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun.bind(this, input, e)));

            if (h.onValid && h.onInvalid) {
                input.on("input", () => {
                    this.checkInputLength(e, input, h.onValid, h.onInvalid);
                });
            }
        };

        let onblur, submit, cancel;
        if (autosave) {
            onblur = 'submit';
        } else {
            onblur = 'ignore';
            submit = i18n.t("generic.okbtn");
            cancel = i18n.t("generic.cancelbtn");
        }

        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            autosave: autosave,
            type: type,
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            height: 'inherit',
            rows: 1,
            width: '',
            onblur: onblur,
            data: text => $('<div />').html(text).text().trim(),
            customTag: {
                value: "{}",
                title: i18n.t("voucher.selectCustomTag"),
                selectorWindow: "#customTagSelector",
                type: type
            },
            submit: submit,
            cancel: cancel,
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find(type === 'text' ? 'input' : 'textarea')) : null,
            onreset: () => h.onReset ? h.onReset(e) : null
        });
    }

    makeEditableMsisdn(i, e) {
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const preValue = $(e).text();
        const h = this.extractHandlers(e);
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun));
            input.on("input", () => this.checkNumberType(e, input, h.onValid, h.onInvalid));
            input.on("blur", () => $('#msisdn-error-message').hide().empty());

        };

        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            type: 'text',
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            height: 'inherit',
            width: 'inherit',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onblur: 'ignore',
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
            onreset: (settings, el) => {
                if (h.onReset) {
                    let c;
                    try {
                        const parsedPhoneNum = callingCode.parseAndKeepRawInput(preValue);
                        c = callingCode.getRegionCodeForNumber(parsedPhoneNum);
                    } catch (e) {
                        return false;
                    }
                    return h.onReset(e, c, $(el).find('input'));
                } else return null;
            }
        });
    }

    makeEditableEmail(i, e) {
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS
        const h = this.extractHandlers(e);
        const onedit = h.onEdit;
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun));
            input.on("input", () => {
                this.checkEmail(e, input, h.onValid, h.onInvalid);
            });

        };
        $(e).editable((value, settings) => this.handleUpdate(value, settings, e), {
            type: 'text',
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            height: 'inherit',
            width: '',
            onblur: 'ignore',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
            onedit: onedit,
            onreset: () => h.onReset ? h.onReset(e) : null
        });
    }

    makeEditableUrl(i, e) {
        const textplaceholder = $(e).data('placeholder') || i18n.t("generic.editclick");
        const placeholder = `<placeholder>${textplaceholder}</placeholder>`; //dummy meaningless tag to distinguish inside CSS

        const h = this.extractHandlers(e);
        const p = input => {
            $(input).attr('placeholder', i18n.t("generic.editing"));
            _.chain(h.on).pairs().each(([key, fun]) => fun && input.on(key, fun));
            $(input).css('text-align', 'inherit');
            input.on("input", () => {
                const url = input.val();
                this.checkUrl(input, url, h.onValid, h.onInvalid);
            });

        };
        $(e).editable((value, settings) => {
            if (value !== '') {
                if (value.indexOf('http://') === -1 && value.indexOf('https://') === -1) {
                    const protocol = 'http://';
                    value = protocol.concat(value);
                }
                // Check if url is accessible
                $.ajaxDefaultQ({
                    url: "/CampaignCloud/checkurl", //Caveat: app-specific URL
                    data: {
                        url: value
                    },
                    success: (data) => {
                        if (this.onTestUrl) this.onTestUrl(data, this.$el);
                    }
                });
            } else
                if (e.dataset.prop === "privacyPolicyURL") value = 'https://www.tellody.com/index.php/privacy-policy';
                else value = null;

            return this.handleUpdate(value, settings, e);
        }, {
            type: 'text',
            tooltip: i18n.t("generic.editclick"),
            placeholder,
            preprocess: p,
            event: 'click',
            onblur: 'ignore',
            width: '',
            height: 'inherit',
            submit: i18n.t("generic.okbtn"),
            cancel: i18n.t("generic.cancelbtn"),
            onsubmit: (settings, el) => h.onSubmit ? h.onSubmit($(el).find('input')) : null,
            onreset: (settings, el) => h.onReset ? h.onReset($(el).find('input')) : null,
            ontesturl: (settings, el) => h.onTestUrl ? h.onTestUrl($(el).find('input')) : null
        });
    }

    makeEditable(i, e) {
        if ($(e).hasClass("inputWithCustomTag")) {
            return this.makeEditableTextWithCustomTag(i, e, 'text', "customTag");
        } else if ($(e).hasClass("textareaWithCustomTag")) {
            return this.makeEditableTextWithCustomTag(i, e, 'textarea', "customTag");
        } else if ($(e).hasClass("datepicker")) {
            return this.makeEditableDatepicker(i, e);
        } else if ($(e).hasClass("datetimepicker")) {
            return this.makeEditableDatetimepicker(i, e);
        } else if ($(e).hasClass("checkbox")) {
            return this.makeEditableCheckbox(i, e);
        } else if ($(e).hasClass("select")) {
            return this.makeEditableSelect(i, e);
        } else if ($(e).hasClass("formattedselect")) {
            return this.makeEditableFormattedSelect(i, e);
        } else if ($(e).hasClass("html")) {
            return this.makeEditableHtmlWysiwyg(i, e);
        } else if ($(e).hasClass("wysiwyg")) {
            return this.makeEditableWysiwyg(i, e);
        } else if ($(e).hasClass("msisdn")) {
            return this.makeEditableMsisdn(i, e);
        } else if ($(e).hasClass("email")) {
            return this.makeEditableEmail(i, e);
        } else if ($(e).hasClass("url")) {
            return this.makeEditableUrl(i, e);
        } else if ($(e).hasClass("textarea")) {
            return this.makeEditableDefault(i, e, 'textarea');
        } else if ($(e).hasClass("combobox")) {
            return this.makeEditableCombobox(i, e, 'combobox');
        } else if ($(e).hasClass("decimal")) {
            return this.makeEditableDecimal(i, e);
        } else if ($(e).hasClass("duration")) {
            return this.initDurationPicker(e);
        } else {
            return this.makeEditableDefault(i, e, 'text');
        }
    }

    @on('click .delete')
    async promptDelete(event) {
        const result = await dhtmlx.confirm({
            type: "confirm",
            text: `${i18n.t("generic.abouttodelete")} ${this.model.myName()}. ${i18n.t("generic.continue")}`,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no")
        });
        if (result) {
            await this.handleDelete(this);
        }
    }
    @on("click #clone_html")
    serveHtml(){
        var id = this.model.get("id")
        console.log("from generic view");
        location.href = `/CampaignCloud/emailRetrieve/${id}`;
    }
    @on('click .clone')
    async promptClone(event) {
        const result = await dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("generic.abouttoclone") + this.model.myName() + i18n.t("generic.continue"),
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no")
        });
        if (result) {
            await this.handleClone(this);
        }
    }

    async handleDelete() {
        try {
            const data = await this.model.destroy();
            this.deleteCallback(data);
        } catch (e) {
            this.deleteCallbackError(e);
        }
    }

    async handleClone() {
        try {
            const data = await this.model.createClone();
            this.cloneCallback(data);
        } catch (e) {
            this.cloneCallbackError(e);
        }
    }

    deleteCallback(data) {
        this.model.clear();
        this.render();
        this.$el.remove();
        $.Notify.show(i18n.t("generic.deletionoutcome") + ' = ' + (Optional.ofNullable(data.outcome).orElse("")));
    }

    deleteCallbackError(data) {
        $.Notify.error(i18n.t("generic.deletionerror") + ' = ' + (Optional.ofNullable(data.status).orElse("")) + ', ' + i18n.t("generic.outcome") + ' = ' + (Optional.ofNullable(data.outcome).orElse("")));
    }

    cloneCallback(data) {
        $.Notify.show(i18n.t("generic.cloneoutcome") + ' = ' + Optional.ofNullable(data.outcome).orElse(""));
    }

    cloneCallbackError(data) {
        $.Notify.error(i18n.t("generic.cloneerror") + ' = ' + (Optional.ofNullable(data.status).orElse("")) + ', ' + i18n.t("generic.outcome") + ' = ' + (Optional.ofNullable(data.outcome).orElse("")));
    }

    handleUpdate(value, settings, e) {
        const oldvalue = value;
        const attr = this.extractAttr(e);
        if ($(e).hasClass("decimal")) {
            value = Number(value);
        } else if (settings.type === "datepicker") {
            const m = moment();
            const ld = m.localeData();
            const df = ld.longDateFormat('L');
            const d = moment(value, df);
            value = "date:" + d.format('YYYY-MM-DD');
        }

        this.updateAttribute(attr, value, oldvalue, settings, e);
    }

    updateAttribute(attr, value, oldvalue, settings, e) {
        if (settings.autosave) {
            this.model.storeAttribute(attr, value);
            if (value === "" && settings.placeholder)
                $(e).html(settings.placeholder);
            else
                $(e).text(value);
        } else {
            this.model.saveAttribute(attr, value, (attributeName, value1, outcome) =>
                this.updateCallback(attributeName, settings.type === "datepicker" ? oldvalue : value1, outcome, e, settings));
        }
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        value = $.trim(value);
        if (settings.type === "formattedselect") {
            value = (settings.transformed_data || settings.retrieved_data || JSON.parse(settings.data))[value];
            $(e).text(value);
        } else if (settings.type === "datepicker") {
            $(e).text(value);
        } else if (settings.type === "wysiwyg") {
            //TODO check for CKEditor
            // const valueOfPlaceholder = $.trim(value).length > 0 ? value : "<placeholder>" + i18n.t("message.typeyourmessagehere") + "</placeholder>";
            // $(e).html(valueOfPlaceholder);
        } else if (settings.type === "datetimepicker") {
            $(e).text(value);
            this.$("#date-button").show();
        } else if (settings.type === "checkbox") {
            if (attributeName === "voucherConfig.cycle") {
                this.render();
            }
        } else {
            if (value === "" && settings.placeholder) {
                $(e).html(settings.placeholder);

            } else {
                $(e).text(value);
            }
        }
        if ($(e).hasClass("countryCode") || $(e).hasClass("invoice-country")) {
            $(e).text(countriesCode.alphaToCountry(value));
            const spriteel = $(e).prev("i");
            spriteel.removeClass();
            spriteel.addClass("flag-icon");
            spriteel.addClass("flag-icon-" + value.toLowerCase());
        }
        const placeholder = $(e).data("placeholder");
        const notify = _.bind((outcome === "OK" ? $.Notify.show : $.Notify.error), $.Notify);
        if (placeholder) {
            notify(i18n.t("generic.attributechangedto", {
                attributeName: placeholder,
                value: value,
                outcome: i18n.t("generic.=" + outcome)
            }));
        } else {
            notify(i18n.t("generic.attributechanged", {value: value, outcome: i18n.t("generic.=" + outcome)}));
        }
        if ("OK" !== outcome) {
            this.render(); //restore original values
        }
        const handler = $(e).data("handler");
        if (this[handler]) this[handler]($(e), outcome);
    }

    extractAttr(e) {
        const $el = $(e);
        return Optional.ofNullable($el.data("prop")).or(
            () => Optional.ofNullable($el.attr("class"))
                .map(classList => classList
                    .split(" ")
                    .find(s => s.indexOf("attr:") === 0)
                ).map(name => name.substring(5))
        ).orElse(null);
    }

    /**
     *
     * @param e
     * @returns {{on: {}}}
     */
    extractHandlers(e) {
        const ret = {on: {}};
        const classes = $(e).attr("class").split(" ");

        const eventhandlersArray = classes.filter(s => s.indexOf("on:") === 0);
        if (eventhandlersArray.length > 0) {
            const handlerSpec = eventhandlersArray[0].substring(3);
            const i = handlerSpec.indexOf(':');
            if (i > -1) {
                const on = handlerSpec.substring(0, i);
                const handler = handlerSpec.substring(i + 1);
                ret.on[on] = _.bind(this[handler], this);
            }
        }

        /**
         *
         * @param prop
         */
        const parseAndAdd = prop => {
            const eventName = prop.replace("on", "").toLowerCase();
            const classHandler =
                () => Optional.ofNullable(classes.find(s => s.indexOf(prop.toLowerCase() + ":") === 0))
                    .map(h => h.substring(prop.length + 1));

            Optional.ofNullable($(e).data(`on-${eventName}`))
                .or(classHandler)
                .map(handler => _.bind(this[handler], this))
                .ifPresent(boundHandler => {
                    ret[prop] = boundHandler;
                });
        };

        parseAndAdd("onValid");
        parseAndAdd("onInvalid");
        parseAndAdd("onSubmit");
        parseAndAdd("onTestUrl");
        parseAndAdd("onReset");
        parseAndAdd("onCancel");
        parseAndAdd("onData");
        parseAndAdd("onEdit");

        const fetcher = $(e).data("fetcher");
        if (fetcher) ret.onData = _.bind(this[fetcher], this);

        return ret;
    }

    checkEmail(e, input, onValid, onInvalid) {
        const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
        const email = input[0].value.trim();
        if (!email.length > 0 || !re.test(email)) {
            onInvalid(e, input);
        } else {
            onValid(e, input);
        }
    }

    checkUrl(input, url, onValid, onInvalid) {
        if (url !== "") {
            try {
                const re = /^(?:(ht|f)tp(s?):\/\/)?$/i;
                let testUrl = !re.test(url)
                    ? new URL("http://" + url)
                    : new URL(url);
                console.log(testUrl);
                if (onValid) {
                    onValid(input);
                }
            } catch (error) {
                console.log(error);
                if (onInvalid) {
                    onInvalid(input);
                }
            }
        } else if (onInvalid) {
            onInvalid(input);
        }
    }

    checkValidNumber(e, input, decimals, positive, onValid, onInvalid) {
        decimals = decimals !== undefined ? `{${decimals},${decimals}}` : "+";
        const value = input[0].value;
        const intPartReg = "[0-9]+";
        const decPartReg = "([.][0-9]+)?";
        const re = new RegExp("^" + (positive ? "" : "-?") + intPartReg + (decimals === "{0,0}" ? "" : decPartReg) + "$", "g");
        if (value !== '' && !re.test(value)) {
            onInvalid(e, input);
        } else {
            onValid(e, input);
        }
    }

    checkNumberType(e, input, onValid, onInvalid) {
        if (input[0].value.indexOf("00") === 0) input[0].value = "+" + input[0].value.substring(2);
        const msisdn = input[0].value;

        try {
            const parsedPhoneNum = callingCode.parseAndKeepRawInput(msisdn, callingCode.defaultCountryCode);
            const regionCode = callingCode.getRegionCodeForNumber(parsedPhoneNum);
            const nt = $(e).data("numbertype");

            const runCCFunction = (func, comp1, comp2) => {
                if (regionCode) {
                    const output = callingCode[func](parsedPhoneNum, regionCode);
                    if (comp1(output)) {
                        input[0].value = callingCode.format(parsedPhoneNum, callingCode.FORMAT.E164);
                        onValid(e, input, regionCode);
                    } else {
                        onInvalid(e, input);
                    }
                } else {
                    let output;
                    try {
                        output = callingCode[func](parsedPhoneNum, callingCode.defaultCountryCode);
                    } catch (e) {
                        onInvalid(e,input);
                        console.info(`Unable to get callingcode::${func} for number: ${msisdn}`, e);
                    }
                    if (comp2(output)) {
                        input[0].value = callingCode.format(parsedPhoneNum, callingCode.FORMAT.E164);
                        onValid(e, input, callingCode.defaultCountryCode);
                    } else {
                        onInvalid(e, input);
                    }
                }
            };

            if (nt !== undefined) {
                runCCFunction("getNumberType", includedIn([nt, 2]), equals(nt));
            } else if (msisdn !== '') {
                runCCFunction("isValidNumber", _.identity, _.identity);
            } else {
                onValid(e, input, regionCode);
            }
        } catch (e) {
            console.info(`Unable to get region code for number: ${msisdn}`, e);
            onInvalid(e, input)
        }
    }

    checkInputLength(e, input, onValid, onInvalid) {
        if (!$(e).data("maxlength")) return;
        const maxLength = parseInt($(e).data("maxlength"));
        const value = input[0].value;
        if (value.length > maxLength) {
            onInvalid(e, input, maxLength);
        } else {
            onValid(e, input);
        }
    }

    initDurationPicker(picker) {

        //TimeDurationPicker for delay in event campaigns
        const delay = this.model.get("delayDuration");
        const timeInterval = this.model.get("delayTimeInterval");
        const delayToSeconds = $.timeDurationPicker.delayConvertToSeconds(delay, timeInterval);

        $(picker).timeDurationPicker({
            lang: i18n.language,
            months: false,
            years: false,
            defaultValue: () => {
                return delayToSeconds;
            },
            onSelect: (element, seconds, duration) => {
                if (duration === "") {
                    $(picker).val(i18n.t("message.noDelay"));
                } else {
                    $(picker).val(duration);
                }
                this.model.saveAttribute("delayDuration", seconds, (at, v, outcome) => {
                    if (outcome === "OK") {
                        this.model.set("delayDuration", seconds);
                    }
                });
                this.model.saveAttribute("delayTimeInterval", "SECONDS", (at, v, outcome) => {
                    if (outcome === "OK") {
                        this.model.set("delayTimeInterval", "SECONDS");
                    }
                });
            }
        });

        if (delay === 0) {
            $(picker).val(i18n.t("message.noDelay"));
        }

    }

}

export default GenericView;
